import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.data = {
            id:   this.getData('id'),
            host: this.getData('host'),
        }

        this.events = {
            click: {
                'toggler' : 'open'
            }
        }
    }

    open(e) {
        e.preventDefault()
        this.call('open', this.data, 'ModalVideo')
    }
}
